export const accountViews = {
  botConfig: {
    breadcrumb: {
      listings: "Anuncios",
      current: "Agente IA",
    },
    loading: "Cargando configuración...",
    retry: "Reintentar",
    loadError: "Error al cargar la configuración.",
    units: "{count} unidad | {count} unidades",
    faqsLabel: "FAQs",
    unitFallback: "Unidad",
    active: "Activo",
    inactive: "Inactivo",
    botWhatsapp: "Bot WhatsApp",
    otaIa: "OTA IA",
    saving: "Guardando...",
    cancel: "Cancelar",
    assistant: {
      title: "Asistente WhatsApp",
      desc: "Activa el bot automático para responder a tus huéspedes por WhatsApp.",
    },
    ota: {
      title: "OTA IA",
      desc: "Responde automáticamente mensajes de Booking.com, Airbnb y otras OTAs.",
      warn: "Activa primero el Asistente WhatsApp",
    },
    botName: {
      title: "Nombre del asistente",
      desc: "El nombre con el que el bot se presentará a tus huéspedes.",
      empty: "Sin nombre asignado",
      edit: "Editar",
      placeholder: "Ej: María, Sofía, Asistente Virtual...",
      save: "Guardar",
    },
    faqs: {
      title: "Preguntas frecuentes",
      desc: "Estas FAQs se aplican a <strong>todas las unidades</strong> de este listing. El bot las usará para responder a tus huéspedes.",
      add: "Nueva FAQ",
      emptyText: "Aún no tienes preguntas frecuentes configuradas.",
      addFirst: "+ Añadir primera FAQ",
      answerEmpty: "Sin respuesta",
      editTitle: "Editar",
      deleteTitle: "Eliminar",
      questionLabel: "Pregunta",
      answerLabel: "Respuesta",
      questionPlaceholder: "Escribe la pregunta...",
      answerPlaceholder: "Escribe la respuesta que verá el huésped...",
      saveChanges: "Guardar cambios",
    },
    addModal: {
      title: "Nueva pregunta frecuente",
      questionLabel: "Pregunta",
      questionPlaceholder: "Ej: ¿A qué hora es el check-in?",
      answerLabel: "Respuesta",
      answerPlaceholder: "Ej: El check-in es a partir de las 15:00h. Si llega antes, puede dejar el equipaje...",
      submit: "Añadir FAQ",
    },
    deleteModal: {
      title: "Eliminar pregunta",
      confirm: "¿Estás seguro de que quieres eliminar esta FAQ?",
      deleting: "Eliminando...",
      submit: "Sí, eliminar",
    },
    types: {
      apartment: "Apartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      room: "Habitación",
      studio: "Estudio",
      default: "Alojamiento",
    },
    toast: {
      botOn: "Bot activado",
      botOff: "Bot desactivado",
      botError: "Error al cambiar el estado del bot",
      otaOn: "OTA IA activada",
      otaOff: "OTA IA desactivada",
      otaError: "Error al cambiar el estado de OTA IA",
      nameUpdated: "Nombre del asistente actualizado",
      nameError: "Error al guardar el nombre",
      faqAdded: "FAQ añadida correctamente",
      faqAddError: "Error al guardar la FAQ",
      faqUpdated: "FAQ actualizada",
      faqUpdateError: "Error al actualizar la FAQ",
      faqDeleted: "FAQ eliminada",
      faqDeleteError: "Error al eliminar la FAQ",
    },
  },

  listingIndex: {
    title: "Anuncios",
    subtitle: "Gestiona la configuración central de cada uno de tus anuncios.",
    countFiltered: "{shown} de {total} anuncios",
    count: "{count} anuncio | {count} anuncios",
    searchPlaceholder: "Buscar por nombre, ID o tipo…",
    clear: "Limpiar",
    loadErrorTitle: "No se pudieron cargar los alojamientos",
    retry: "Reintentar",
    emptyTitle: "Sin anuncios",
    emptyText: "Aún no tienes ningún anuncio registrado.",
    noResultsTitle: 'Sin resultados para "{query}"',
    noResultsText: "Prueba con otro nombre, ID o tipo de anuncio.",
    clearSearch: "Limpiar búsqueda",
    dragSearchHint: "Limpia la búsqueda para reordenar",
    dragHint: "Arrastrar para reordenar",
    units: "{count} unidad | {count} unidades",
    botActiveTitle: "Bot GPT activo",
    channelTitle: "Conectado a Channex",
    icalTitle: "Sincronización iCal",
    editTitle: "Editar nombre",
    modal: {
      title: "Editar nombre del anuncio",
      nameLabel: "Nombre del anuncio",
      namePlaceholder: "Ej: Apartamentos Costa Sol",
      orderLabel: "Orden del listing",
      info: "El <strong>anuncio</strong> agrupa todas las propiedades que comparten una misma configuración, mensajes de bienvenida y políticas. El nombre que asignes aquí identificará al grupo en el panel y en los canales de distribución conectados.",
      cancel: "Cancelar",
      save: "Guardar cambios",
    },
    types: {
      apartment: "Apartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      room: "Habitación",
      studio: "Estudio",
      default: "Alojamiento",
    },
    toast: {
      connectionError: "Error de conexión.",
      reorderSuccess: "Orden actualizado con éxito.",
      reorderError: "No se pudo actualizar el orden de los anuncios.",
      saveSuccess: "Listing actualizado correctamente.",
      saveError: "Error al guardar el listing.",
    },
  },

  unitDetail: {
    back: "Volver al anuncio",
    eyebrow: "Unidad",
    save: "Guardar",
    cancel: "Cancelar",
    editNameTitle: "Editar nombre de la unidad",
    nameFallback: "Unidad",
    types: {
      apartment: "Apartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      camping: "Camping",
      room: "Habitación",
      studio: "Estudio",
      default: "Alojamiento",
    },
    deleteLink: "Eliminar unidad...",
    dangerNoteBefore: "Elimina la unidad del anuncio",
    dangerNoteAfter: "de WACheckin. Esta acción no se puede deshacer.",
    cards: {
      description: { title: "Descripción", sub: "Detalles de la unidad" },
      capacity: { title: "Capacidad", sub: "Huéspedes y camas" },
      services: { title: "Equipamiento y comodidades", sub: "Lo que ofrece, con sus fotos" },
      rules: { title: "Horarios", sub: "Horarios de entrada y salida" },
      arrival: { title: "Instrucciones de Llegada", sub: "Cómo llegar y entrar · con hora de envío" },
      smartlocks: { title: "Cerraduras y acceso", sub: "Cómo entra el huésped" },
      checkout: { title: "Mensaje de salida", sub: "Recordatorio de checkout · plantilla" },
      scheduled: { title: "Mensajes programados", sub: "Mensajes solo para esta unidad" },
      unitFaq: { title: "Preguntas y respuestas", sub: "Específicas de esta unidad para el agente", badge: "IA" },
      welcome: { title: "Mensaje de bienvenida", sub: "Mensaje propio de esta unidad" },
      stockExtra: {
        title: "Stock extra",
        subOff: "Desactivado · recoge reservas de otra unidad",
        subOn: "Refuerza a {name}",
        subOnGeneric: "Refuerza a otra unidad",
        badge: "Activo",
      },
    },
    sections: {
      aiOnlyLabel: "Preguntas frecuentes de la unidad",
      aiOnlyDesc: "El agente las usará con prioridad cuando atienda a un huésped alojado en esta unidad.",
      specificLabel: "Configuraciones específicas para esta unidad",
      detailLabel: "Detalla esta unidad",
      detailDesc: "Información adicional que usamos para reservas directas y nutrir al Agente IA.",
    },
    stockExtra: {
      title: "Stock extra",
      intro: "En Booking o en Airbnb puedes tener un solo anuncio con cupo para varios apartamentos: como solo se puede mapear uno, el canal manda todas esas reservas contra la misma unidad y se apilan en overbooking.",
      how: "Si marcas esta unidad como stock extra de otra, las reservas que choquen con la principal se guardan aquí y se le avisa al canal para que allí también aparezcan en esta unidad.",
      purpose: "Es una herramienta de traslado: se enciende para traer lo que ya tenías vendido en la OTA y se apaga cuando cada apartamento tenga su propio anuncio.",
      loading: "Cargando...",
      activeLabel: "Refuerza a {name}",
      activeHint: "Las reservas del canal que choquen con {name} se guardan en esta unidad.",
      activeBadge: "Activo",
      otherUnit: "otra unidad",
      warnTitle: "No lo enciendas si cada apartamento ya tiene su propio anuncio mapeado en la OTA:",
      warnText: "ahí el canal ya manda cada reserva a su unidad, y con el stock extra puesto una reserva acabaría en un apartamento que no es el que vendiste.",
      principalOf: "Otras unidades ya se apoyan en esta:",
      chooseLabel: "Unidad principal",
      chooseDesc: "Elige la unidad cuyas reservas se guardarán en «{unit}» cuando choquen entre ellas.",
      noCandidates: "No hay ninguna otra unidad a la que reforzar en este anuncio.",
      activate: "Activar el stock extra",
      change: "Cambiar la unidad principal",
      saving: "Guardando...",
      removeBtn: "Quitar el stock extra",
      removeNote: "Las reservas que ya se guardaron aquí no se mueven: se quedan en esta unidad.",
      errorCarga: "No se ha podido leer la configuración del stock extra. Si acabas de actualizar, prueba a recargar la página.",
      reintentar: "Reintentar",
      toastLoadError: "No se pudo cargar el stock extra.",
      toastSaveError: "No se pudo guardar el stock extra.",
    },
    toast: {
      nameEmpty: "El nombre no puede estar vacío",
      nameUpdated: "Nombre actualizado",
      nameError: "No se pudo actualizar el nombre",
    },
  },

  miCuenta: {},
};
